import { Link, LinkProps, useLocation } from "react-router-dom";

export const LocationLink = (
  props: Omit<LinkProps, "state"> & React.RefAttributes<HTMLAnchorElement>,
) => {
  const location = useLocation();

  return <Link {...props} state={{ from: location }} />;
};
